import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEscalatorUpinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.087 42H9a6 6 0 1 0 0 12h6.432a12 12 0 0 0 9.163-4.252l22.263-26.33A4 4 0 0 1 49.913 22H55a6 6 0 1 0 0-12h-6.432a12 12 0 0 0-9.163 4.252l-22.263 26.33A4 4 0 0 1 14.087 42z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 22,
				cy: 18,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M19 38.5V25a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6m26 12L41 53" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M43 43h8v8"
			})
		]
	})
});
export default SvgEscalatorUpinline;
